import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/frontend/components/about/team.tsx");
